
import { useEffect, useState, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import { FilterSvg, ChevronDownSvg,  ChevronUpSvg } from "../../icons/Icon";
import { Loading } from "../Loaders";
import { LoadingSvg } from "../../icons/Icon";
import { dispatch_setFilter_Event } from "../../events/SearchEvents";

const CheckboxListItem = (p) => {

    const input = useRef(null);

    return (
        <div className="control-check-item">
            <label>
                <input
                    ref={input}
                    type="checkbox"
                    id={p.label}
                    name={'brand'}
                    value={p.label}
                    onChange={p.onChange}
                />
                <span>{p.label}</span>
                <b>{p.value}</b>
            </label>
        </div>
    );
};
const ControlCheckList = (p) => {

    const [selected, setSelected] = useState([]);
    const [open, setOpen] = useState(false);

    const checked = useCallback((e) => {
        dispatch_setFilter_Event(p.heading, e.target);
    }, [selected]);

    const toggle = (e) => {
        //console.log('toggle', e.target);
        if(e.target){
            if(e.target.classList.contains('close')){
                e.target.classList.replace('close','open');
            }else if(e.target.classList.contains('open')){
                e.target.classList.replace('open','close');
            }
        }
    };
    return (
        <div className="control-check-list">
            <h6 onClick={toggle} className="close"><span>Filter by : </span>{` ${p.heading} `} {open ? <ChevronUpSvg /> : <ChevronDownSvg/>}</h6>
            {p.data ? Object.entries(p.data).map(([key, value], index) => {
                return <CheckboxListItem key={`${key}-${value}-${index}`} label={key} value={value} onChange={checked} />;
            }) : <></>}
        </div>
    );
};
const FilterControls = (p) => {

    const filter = useSelector(state => state.common.filter.data);
    const brands = useSelector(state => state.common.brands.data);
//console.log('FilterControls', brands, filter);
    const renderFilter = (f) => {
        let components = [];
        if (f) {
            for (let key in f) {
                //console.log(key, f[key]);
                for (let label in f[key]) {
                    components.push(<ControlCheckList key={`${label}`} heading={label} data={f[key][label]} />);
                }

            }
        }
        return components;
    };

    return (
        <div className="filter-controls">
            <div className="filter-controls-header">
                <h5>Filter</h5><FilterSvg />
            </div>
            <ControlCheckList key={'brands'} heading={'brands'} data={brands} onChange={p.onChange} />
            <>{renderFilter(filter)}</>
        </div>
    );
};

export default FilterControls;